<div class="pdf-toolbar">
  <div class="logo">
    <img *ngIf="!base64PdfModal" src="assets/img/logoBanner.png" alt="Gesvatec logo icono">
  </div>
  <div class="buttons">
    <div class="start">
      <div>
        <i class="fa-solid fa-chevron-left" (click)="onIncrementPage(-1)"></i>
      </div>
      <span>{{page}} / {{numPages}}</span>
      <div>
        <i class="fa-solid fa-chevron-right" (click)="onIncrementPage(1)"></i>
      </div>
    </div>
    <div class="start">
      <div>
        <i class="fa-solid fa-minus" (click)="onIncrementZoom(-0.1)"></i>
      </div>
      <span>{{zoomValue}} %</span>
      <div>
        <i class="fa-solid fa-plus" (click)="onIncrementZoom(0.1)"></i>
      </div>
    </div>
    <div>
      <div>
        <i class="fas fa-file" (click)="showOnePage()" title="{{ 'viewer-pdf.vistaUnaPagina' | translate }}"></i>
      </div>
      <div>
        <i class="fa-solid fa-book-open" (click)="showTwoPages()" title="{{ 'viewer-pdf.vistaDosPaginas' | translate }}"></i>
      </div>
    </div>
  </div>
  <div class="end"></div>
</div>
